var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"qr-box"},[_c('div',{staticClass:"text"},_vm._l((_vm.text),function(v,i){return _c('div',{key:i,staticClass:"text-item"},[_vm._v(_vm._s(v))])}),0),_vm._v(" "),_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":_vm.QRImage,"alt":""}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1ad70b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/qr.vue
// module id = null
// module chunks = 